import { getStoredAuthUser, persistAuthUser } from "./backendApi";

const pickDefined = (obj) => {
  if (!obj) return {};
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined)
  );
};

export {
  clearStoredAuthUser,
  getAccessToken,
  getRefreshToken,
  getStoredAuthUser,
  normalizeAuthUser,
  persistAuthUser,
} from "./backendApi";

export const getStoredAuthUserId = () => {
  const authUser = getStoredAuthUser();
  return authUser?.id ?? null;
};

const mergeAuthUser = (current, patch) => {
  const patchDefined = pickDefined(patch);
  const next = { ...current, ...patchDefined };

  if (current?.profile || patchDefined?.profile) {
    next.profile = {
      ...(current?.profile || {}),
      ...(patchDefined?.profile || {}),
    };
  }

  if (current?.access) next.access = current.access;
  if (current?.refresh) next.refresh = current.refresh;

  return next;
};

export const updateStoredAuthUser = (patch) => {
  const current = getStoredAuthUser();
  if (!current) return;
  persistAuthUser(mergeAuthUser(current, patch));
};

export const updateStoredAuthUserFromUser = (user) => {
  if (!user) return;
  updateStoredAuthUser({
    id: user.id,
    username: user.username,
    email: user.email,
    phone_number: user.phone_number,
    profile: user.profile
      ? {
          first_name: user.profile.first_name,
          last_name: user.profile.last_name,
          address: user.profile.address,
        }
      : undefined,
  });
};
